import { addHeader } from '@dce-front/util-fetch';
import { isDebugRequest } from '../../server/helpers/isDebugRequest';
import type { HodorCinematicParametersServerSpecific } from './types';

export const getHodorHeaders = (
  request: HodorCinematicParametersServerSpecific['request'] | undefined,
  baseHeaders: HeadersInit | undefined,
  userAgent?: string,
): HeadersInit | undefined => {
  const headersWithDebug =
    request && isDebugRequest(request)
      ? addHeader(baseHeaders, 'xx-debug', '0')
      : baseHeaders;

  return userAgent
    ? addHeader(headersWithDebug, 'user-agent', userAgent)
    : headersWithDebug;
};
